import { render, staticRenderFns } from "./phoneBooksSFQ.vue?vue&type=template&id=00508ed1&scoped=true&"
import script from "./phoneBooksSFQ.vue?vue&type=script&lang=js&"
export * from "./phoneBooksSFQ.vue?vue&type=script&lang=js&"
import style0 from "./phoneBooksSFQ.vue?vue&type=style&index=0&id=00508ed1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00508ed1",
  null
  
)

export default component.exports